import styles from './LandingLayout.module.css';

const TermsPage = () => (
  <section className={styles.section}>
    <div className={styles.sectionInner}>
      <div className={styles.sectionLabel}>Legal</div>
      <h2 className={styles.sectionTitle}>Terms of Service</h2>
      <div className={styles.legalBody}>
        <p><strong>Effective date:</strong> 1 January 2026</p>
        <p>
          JainamSevaSetu is a software platform for managing donations and funding for Jain community temples.
          By registering or using this platform, you agree to these Terms of Service.
        </p>

        <h3>1. Operator</h3>
        <p>
          This platform is owned and operated by the <strong>JainamSevaSetu</strong> team. For any queries regarding
          these terms, contact us at <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>.
        </p>

        <h3>2. Acceptance</h3>
        <p>By registering or using JainamSevaSetu, you agree to these Terms of Service. If you do not agree, please do not use the platform.</p>

        <h3>3. Eligibility</h3>
        <p>You must be at least 18 years old to create an account. Derasar admins must be authorised representatives of the religious organisation they register.</p>

        <h3>4. Account Responsibilities</h3>
        <p>You are responsible for maintaining the confidentiality of your login credentials. You agree not to share your account with others or use another person's account without permission.</p>

        <h3>5. Acceptable Use</h3>
        <p>The platform may only be used for lawful donation and financial management activities of registered Jain temple organisations. You must not use the platform to process fraudulent transactions or misrepresent financial records.</p>

        <h3>6. Platform Availability</h3>
        <p>JainamSevaSetu strives to maintain high availability but does not guarantee uninterrupted access. We reserve the right to perform maintenance, modify features, or discontinue the service with reasonable notice.</p>

        <h3>7. Intellectual Property</h3>
        <p>JainamSevaSetu and all associated software, branding, and content are the intellectual property of the <strong>JainamSevaSetu</strong> team. You may not copy, modify, or distribute any part of the platform without written permission.</p>

        <h3>8. Termination</h3>
        <p>We may suspend or terminate accounts found to be in violation of these terms, or upon request from the account holder. Derasars that allow their subscription to lapse will have their data retained for 90 days before deletion.</p>

        <h3>9. Limitation of Liability</h3>
        <p>The platform is provided "as is." JainamSevaSetu is not liable for any financial decisions made based on data generated by the platform. Always verify financial records with a qualified accountant.</p>

        <h3>10. Governing Law</h3>
        <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in India.</p>

        <h3>11. Contact</h3>
        <p>
          <strong>JainamSevaSetu</strong><br />
          Email: <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>
        </p>
      </div>
    </div>
  </section>
);

export default TermsPage;
